import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, InputGroup, FormGroup } from "reactstrap";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import * as moment from 'moment';

import Flatpickr from 'react-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import 'flatpickr/dist/themes/material_red.css';

import PropTypes from 'prop-types';
import _ from "lodash";
import { getDistribuitorBuysKgsPieces, getDistribuitorDashboardExpenses, getProviders, getProvidersSelect } from "helpers/backend_helper";
import { rangeDatePicker } from "helpers/functions";

const initialPeriod = moment().startOf('month').format('YYYY-MM-DD') + '/' + moment().endOf('month').format('YYYY-MM-DD');

const nf2 = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

const getOptionsDefault = (categories) => {
  return {
    chart: {
      toolbar: "false",
      dropShadow: {
        enabled: !0,
        color: "#000",
        top: 18,
        left: 7,
        blur: 8,
        opacity: 0.2,
      },
    },
    dataLabels: {
      enabled: !1,
    },
    xaxis: {
      categories: categories
    },
    colors: ['#a0a0a0', "#f46a6a", '#3b5998', '#1da1f2', '#c4302b', '#e4405f'],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return "$" + nf2.format(value);
        }
      },
    },
  }
};

function Expenses(props) {
  const [monthIndex, setMonthIndex] = useState(null)
  const [months, setMonths] = useState(props.months)
  const [dataGraph, setDataGraph] = useState(null)
  const [totals, setTotals] = useState([0, 0, 0, 0])
  const [percent, setPercent] = useState(0)
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(null);
  const [provider, setProvider] = useState('')
  const [providers, setProviders] = useState(props.providers)
  const [period, setPeriod] = useState(initialPeriod)

  const [buysKindGraph, setBuysKindGraph] = useState(true);

  useEffect(() => {
    setProviders(props.providers);
  }, [props.providers]); // 👈️ add props as dependencies

  useEffect(() => {
    getDataServer(initialPeriod, '');
  }, []); // 👈️ add props as dependencies


  const getPercent = (monthIndex) => {
    return monthIndex > 0 && totals[monthIndex - 1] > 0 ? (totals[monthIndex] - totals[monthIndex - 1]) / totals[monthIndex - 1] * 100 : 0
  }

  async function getDataServer(period, provider) {
    const config = {
      params: {
        period: period,
        provider: provider,
      }
    }
    setLoading(true);
    const piecesKgs = await getDistribuitorBuysKgsPieces(config);
    const dataDashboard = await getDistribuitorDashboardExpenses(config);
    setLoading(false);
    console.log(dataDashboard);
    setOptions(getOptionsDefault(dataDashboard.labels))
    setDataGraph({
      compras: dataDashboard,
      pieces: piecesKgs.pieces,
      kgs: piecesKgs.kgs
    });
    // La gráfica del año anterior dibuja el periodo completo, pero los totales de la
    // tarjeta acumulan solo hasta el día equivalente de hoy (previous_to_date), para no
    // comparar un mes en curso incompleto contra un mes cerrado.
    setTotals([
      Number(dataDashboard.previous_to_date || 0).toFixed(2),
      dataDashboard.current.reduce((prev, cur) => { return prev + (Number(cur) ? Number(cur) : 0) }, 0).toFixed(2),
      Number(piecesKgs.kgs.previous_to_date || 0).toFixed(2),
      piecesKgs.kgs.current.reduce((prev, cur) => { return prev + (Number(cur) ? Number(cur) : 0) }, 0).toFixed(2),
      Number(piecesKgs.pieces.previous_to_date || 0).toFixed(2),
      piecesKgs.pieces.current.reduce((prev, cur) => { return prev + (Number(cur) ? Number(cur) : 0) }, 0).toFixed(2)
    ]);
    setMonthIndex(1);
  }

  const handleMonthSelect = (e) => {
    setPeriod(e.val);
    getDataServer(e.val, provider);
  }

  const handleSelectedProvider = (e) => {
    setProvider(e);
    getDataServer(period, e);
  }

  console.log('provider', provider)

  return (
    <React.Fragment>
      <Col xl="12">
        <Card>
          <CardBody>
            <div className="clearfix">
              <div className="float-end">
                <FormGroup className="mb-4 d-inline-block" style={{ width: '230px' }}>
                  <InputGroup size="sm">
                    <Flatpickr
                      className="form-control d-block"
                      placeholder=""
                      onChange={(dates) => {
                        if (dates.length !== 2) return;
                        handleMonthSelect({
                          key: 'dates',
                          val: rangeDatePicker(dates)
                        })
                      }}
                      options={{
                        mode: "range",
                        dateFormat: "Y-m-d",
                        locale: Spanish,
                        defaultDate: initialPeriod.split('/')
                      }}
                    />
                    <label className="input-group-text">Periodo</label>
                  </InputGroup>
                </FormGroup>
              </div>
              <div className="float-end me-2">
                <div className="input-group input-group-sm">
                  <select
                    style={{ maxWidth: '200px' }}
                    className="form-select form-select-sm"
                    defaultValue={0}
                    onChange={(e) => { handleSelectedProvider(e.target.value); }}
                  >
                    <option selected={provider == ''} value={''}>--- Todos ---</option>
                    {providers.map(e => (
                      <option selected={provider == e.id} value={e.id} key={e.id}>{e.name}</option>
                    ))
                    }
                  </select>
                  {/* <div className="input-group-append"> */}
                  <label className="input-group-text">Proveedor</label>
                  {/* </div> */}
                </div>
              </div>
              <div className="float-end">
                <div className="form-check form-switch d-inline-block me-3">
                  <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={buysKindGraph} onClick={() => { setBuysKindGraph(!buysKindGraph) }} />
                  <label className="form-check-label">Piezas y Kgs / Importe</label>
                </div>
              </div>
              {buysKindGraph ?
                <h4 className="card-title mb-4">Compras</h4> :
                <h4 className="card-title mb-4">Compras en Piezas y Kgs</h4>
              }
            </div>

            <Row>
              <Col lg="3" className="">
                <div className="text-muted">
                  <div className="mb-4">
                    <p>Periodo actual</p>
                    {buysKindGraph ?
                      <>
                        <h4>$ {monthIndex ? numberFormat.format(totals[monthIndex]) : ''}</h4>
                        <div>
                          <span className={getPercent(monthIndex) >= 0 ? "badge badge-soft-success font-size-12 me-1" : "badge badge-soft-danger font-size-12 me-1"}>
                            {" "}
                            {getPercent(monthIndex).toFixed(2)}%{" "}
                          </span>{" "}
                          <br />
                          comparado con el año anterior
                        </div>
                      </> :
                      <>
                        <h4>
                          {monthIndex ? numberFormat.format(totals[3]) : ''} Kgs <br />
                          {monthIndex ? numberFormat.format(totals[5]) : ''} Piezas
                        </h4>
                        <div>
                          <span className={getPercent(3) >= 0 ? "badge badge-soft-success font-size-12 me-1" : "badge badge-soft-danger font-size-12 me-1"}>
                            {" "}
                            {getPercent(3).toFixed(2)}%{" "}
                          </span>{" "}
                          <br />
                          comparado con el año anterior
                        </div>
                      </>
                    }
                  </div>

                  <div className="mt-4">
                    <p className="mb-2">Año anterior</p>
                    {buysKindGraph ?
                      <h5>$ {monthIndex ? numberFormat.format(monthIndex > 0 ? totals[monthIndex - 1] : 0) : ''}</h5>
                      :
                      <h5>
                        {monthIndex ? numberFormat.format(monthIndex > 0 ? totals[2] : 0) : ''} Kgs<br />
                        {monthIndex ? numberFormat.format(monthIndex > 0 ? totals[4] : 0) : ''} Pzas
                      </h5>
                    }
                  </div>
                </div>

                <div className="mt-5 d-none">
                  <Link to="#" className="btn btn-danger btn-sm">
                    Ir a reporte Compras{" "}
                    <i className="mdi mdi-chevron-right ms-1"></i>
                  </Link>
                </div>
              </Col>

              <Col lg="9">
                <div id="line-chart" dir="ltr">
                  {dataGraph && <ReactApexChart
                    series={
                      buysKindGraph ?
                        [
                          {
                            name: "Compras Año Anterior",
                            data: dataGraph.compras.previous.map(function (k) { return k.toFixed(2) }),
                          },
                          {
                            name: "Compras Periodo Actual",
                            data: dataGraph.compras.current.map(function (k) { return k.toFixed(2) }),
                          },
                        ] :
                        [
                          {
                            name: "Kgs Año Anterior",
                            data: dataGraph.kgs.previous.map(function (k) { return k.toFixed(2) }),
                          },
                          {
                            name: "Kgs Periodo Actual",
                            data: dataGraph.kgs.current.map(function (k) { return k.toFixed(2) }),
                          },
                          {
                            name: "Piezas Año Anterior",
                            data: dataGraph.pieces.previous.map(function (k) { return k.toFixed(2) }),
                          },
                          {
                            name: "Piezas Periodo Actual",
                            data: dataGraph.pieces.current.map(function (k) { return k.toFixed(2) }),
                          },
                        ]}
                    options={options}
                    type="line"
                    height={320}
                    className="apex-charts"
                  />
                  }
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
}

Expenses.propTypes = {
  months: PropTypes.array,
  options: PropTypes.any,
  dashboardData: PropTypes.array,
  currentMonth: PropTypes.number,
  prevMonth: PropTypes.number,
  providers: PropTypes.array,
}

export default Expenses;
